<template>
  <div id="pageWrapper">
    <div class="columns">
      <div class="column">
        <button v-if="isAdmin" type="button" class="button is-pulled-right" @click="edit">Pagina bewerken</button>
      </div>
    </div>

    <div class="columns">
      <div class="column">
        <template v-if="editing">
          <div class="field">
            <input type="text" v-model="page.title" class="input">
          </div>

          <div class="field">
            <vue-editor v-model="page.content" :editorToolbar="customToolbar"></vue-editor>
          </div>

          <button type="button" class="button is-primary" @click="save">Opslaan</button>
          <button type="button" class="button" @click="cancel">Annuleren</button>
        </template>

        <template v-else>
          <div class="columns">
            <div class="column is-half">
              <div class="editor-content">
                <h1 class="title">{{ page.title }}</h1>

                <div v-html="page.content" class="editor"></div>

                <template v-if="id === 2">
                  <hr>
                  <contact-form></contact-form>
                </template>
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { VueEditor } from 'vue2-editor'
import ContactForm from '@/components/contact/ContactForm'

export default {
  props: [
    'id'
  ],
  components: {
    VueEditor,
    ContactForm
  },
  data () {
    return {
      page: {},
      editing: false,
      customToolbar: [
        [{ 'header': 1 }, { 'header': 2 }],
        ['bold', 'italic', 'underline'],
        [{ list: 'ordered'}, {list: 'bullet'}],
        ['link'],
        ['clean']
      ]
    }
  },
  computed: {
    isAdmin () {
      return this.$store.getters.isAdmin
    }
  },
  watch: {
    id () {
      this.fetchPage()
    }
  },
  created () {
    this.fetchPage()
  },
  methods: {
    fetchPage () {
      axios.get(
        `/pages/${this.id}`
      ).then(
        (res) => {
          this.page = res.data
        }
      ).catch(
        (err) => {
          console.log(err)
        }
      )
    },
    edit () {
      this.editing = true
    },
    cancel () {
      this.editing = false
    },
    save () {
      axios.put(
        `/pages/${this.id}`,
        this.page
      ).then(
        (res) => {
          this.editing = false
        }
      ).catch(
        (err) => {
          console.error(err)
        }
      )
    }
  }
}
</script>

<style>
  .editor-content, .editor ol {
    padding: 15px;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/Page.vue